import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, TextField, Typography } from "@mui/material";
import { route } from "preact-router";

export default function DeleteDealUserDialog(props) {
	const [form, setForm] = useState({ confirm: "" });
	const [disabled, setDisabled] = useState(true);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		console.log(form.confirm, form.confirm === "supprimer " + props.state.params.name);
		setDisabled(!(form.confirm === "supprimer"));
		//setDisabled(!(form.confirm === "supprimer " + props.state.params.name));
	}, [form]);
	const handleSubmitDeleteDealUser = () => {
		console.log("handleSubmitNewDeal");
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/98c567fbb3bb409fbbb4d19f2fe2c167/" + props.state.params.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();

						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">Suppression d'un membre du dossier</DialogTitle>
			<DialogContent dividers>
				<Typography variant="h5" gutterBottom>
					Vous souhaitez supprimer
				</Typography>
				<Typography variant="body1" gutterBottom>
					{props.state.params.name}
				</Typography>
				<Typography variant="body1" gutterBottom>
					{"Pour se faire, merci d'écrire le mot \"supprimer\"  en toutes lettres dans le champ ci-dessous"}
					{/* {"Pour le supprimer, merci d'écrire la phrase \"supprimer " + props.state.params.name + '" en toutes lettres dans le champ ci-dessous'} */}
				</Typography>
				<div>
					<TextField
						id="confirm"
						name="confirm"
						variant="outlined"
						style={{
							marginLeft: 0,
							marginRight: 10,
						}}
						placeholder={"supprimer"}
						//placeholder={"supprimer " + props.state.params.name}
						fullWidth
						margin="dense"
						size="small"
						value={form.confirm}
						onChange={handleChange}
					/>
				</div>
			</DialogContent>

			<DialogActions>
				<Button variant="outlined" onClick={handleClose}>
					Annuler
				</Button>
				<Button
					variant="contained"
					onClick={handleSubmitDeleteDealUser}
					//style="margin: 10px;"
					disabled={disabled}
				>
					Supprimer
				</Button>
			</DialogActions>
		</Dialog>
	);
}
